module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.18537/js/img/white_sprocket.svg"